import type { components } from "@/api/types";

import { toDateKey } from "./dateKey";

type CalendarOverride = components["schemas"]["CalendarOverride"];

/**
 * Build a predicate `(date) => isNonWorking` from a calendar's weekly
 * pattern (`weekly_pattern[0..6]` → Mon..Sun, hours per weekday; 0 means
 * non-working) and the list of date-range overrides (override.hours === 0 →
 * non-working, any positive hours → working day even if the weekly pattern
 * says non-working).
 */
export function makeIsNonWorkingDay(
  weekly: number[] | null | undefined,
  overrides: CalendarOverride[] | null | undefined,
): (date: Date) => boolean {
  const w = weekly ?? [8, 8, 8, 8, 8, 0, 0];
  const ovr = overrides ?? [];
  return (date: Date) => {
    // SVAR Gantt передаёт сюда Date в локальной полуночи дня сетки. Сравниваем
    // с override.date_from/date_to (YYYY-MM-DD от backend) тоже в локальной TZ —
    // иначе в зонах с положительным offset (MSK) local-midnight уезжает в UTC
    // на предыдущий день и predicate подсвечивает соседний слот сетки.
    const iso = toDateKey(date);
    for (const o of ovr) {
      if (iso >= o.date_from && iso <= o.date_to) {
        return o.hours === 0;
      }
    }
    const dow = date.getDay(); // 0=Sun … 6=Sat
    const idx = (dow + 6) % 7; // 0=Mon … 6=Sun
    return (w[idx] ?? 1) === 0;
  };
}
